import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';

import { AuthService } from 'src/app/services/auth/auth.service';
import { VehiclesService } from 'src/app/services/vehicles/vehicles.service';
import { BrandsService } from 'src/app/services/brands/brands.service';
import { ModelsService } from 'src/app/services/models/models.service';
import { CustomStorageService } from 'src/app/services/custom-storage/custom-storage.service';
import { GlobalService } from 'src/app/services/global-service/global-service.service';
import { ConstantService } from 'src/app/services/constant/constant.service';
import { TranslateService } from '@ngx-translate/core';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';

@Component({
  selector: 'app-add-vehicle',
  templateUrl: './add-vehicle.component.html',
  styleUrls: ['./add-vehicle.component.scss']
})

export class AddVehicleComponent implements OnInit {
  driver = true;
  electricVehicle: any = {
    user: ''
  };
  selectedBrand: any;
  selectedModel: any;
  brands: [];
  models: [];
  isSubmitted = false;
  isLicensePlateUsed = false;
  licensePlateControl = new UntypedFormControl('', [Validators.required]);
  employees: any;
  enterprise: any;
  Load = false;
  loadingSpinner = false;

  constructor(
    private readonly constantService: ConstantService,
    private readonly translateService: TranslateService,
    private readonly authService: AuthService,
    private readonly vehiclesService: VehiclesService,
    private readonly brandsService: BrandsService,
    private readonly modelsService: ModelsService,
    private readonly enterpriseService: EnterpriseService,
    private readonly storageService: CustomStorageService,
    private readonly globalService: GlobalService
  ) { }

  ngOnInit() {
    this.enterprise = this.storageService.getEnterprise();
    this.getBrandsList();
    this.loadDataEmployee();
  }

  /**
   * function is called to create a electric vehicle.
   */
  onCreateClick() {

    this.isSubmitted = true;

    if (this.licensePlateControl.invalid) {
      return;
    }

    if (this.electricVehicle.user === '') {
      this.electricVehicle.user = null;
    }

    this.Load = true;
    this.isLicensePlateUsed = false;
    this.electricVehicle.ownerType = 'Enterprise';
    this.electricVehicle.licensePlate = this.licensePlateControl.value;
    this.vehiclesService.createVehicle(this.electricVehicle).subscribe(res => {
      this.constantService.showSuccessToast('toast.success-add_vehicle');
      this.constantService.navigateToVehicles('/list');
    }, error => {
      this.Load = false;
      switch (error.status) {
        case 401:
          this.authService.logout();
          break;

        case 409:
          this.isLicensePlateUsed = true;
          this.Load = false;
          break;

        default:
          this.constantService.showErrorToast('toast.error_server');
          break;
      }
    });
  }

  handleLicensePlate(event) {
    this.isLicensePlateUsed = false;
  }

  /**
   * function is called to get list brand.
   */
  getBrandsList() {
    this.loadingSpinner = true;
    this.brandsService.getBrands().subscribe((res: any) => {
      this.loadingSpinner = false;
      const brandsWithModels = res.data.filter(brand => brand.models.length > 0);
      this.brands = brandsWithModels.sort((a, b) => a.name > b.name ? 1 : a.name < b.name ? -1 : 0);
      if (brandsWithModels.length > 0) {
        this.selectedBrand = brandsWithModels[0];
        this.electricVehicle.brand = brandsWithModels[0]._id;
        this.onChangeBrand();
      }
    },
    (error) => {
      this.loadingSpinner = false;
      if (error.status === 401) {
        this.authService.logout();
      }
    });
  }

  /**
   * function is called to change brand in select.
   */
  onChangeBrand(event?) {
    this.models = [];
    let brand = this.electricVehicle.brand;
    if (event) {
      brand = event.value;
    }
    this.modelsService.getModelsByBrand(brand).subscribe((res: any) => {
      this.models = res.models;
      this.selectedModel = res.models[0];
      this.electricVehicle.model = res.models[0]._id;
    },
    (error) => {
      this.loadingSpinner = false;
      if (error.status === 401) {
        this.authService.logout();
      }
    });
  }

  loadDataEmployee() {
    this.loadingSpinner = true;
    this.enterpriseService.getEmployees().subscribe((data: any) => {
      this.loadingSpinner = false;
      this.employees = data.users
      .filter((x) =>(x.type === 'EnterpriseMember' || x.type === 'Member' || x.type === 'EnterpriseOfficer' ) &&
      (x.isAnonymous === false) && (x.isDeleted === false));
      const noneEmployee = {
        username : this.translateService.instant('no_owner_selected'),
        id : '',
      };
      this.employees.push(noneEmployee);
    });
  }

  /**
   * Get Full name of user based on userModel given
   */
  getFullName(owner) {
    return this.globalService.getFullName(owner.username, owner.firstName, owner.lastName);
  }

  onChangeSelect(e) {
    if (e === '') {
      this.driver = false;
    } else {
      this.driver = true;
    }
  }

}
